module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "billing-mangen-ment"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal pt10px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-left": "105px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.chargeRecord == 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.controlCharging(1)
      }
    }
  }, [_vm._v("开始计费")]), _vm._v("  \r\n\t\t\t\t\t"), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.chargeRecord == 2 || _vm.chargeRecord == 3,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.controlCharging(2)
      }
    }
  }, [_vm._v("暂停计费")]), _vm._v("  \r\n\t\t\t\t\t"), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.chargeRecord == 3,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.controlCharging(3)
      }
    }
  }, [_vm._v("停止计费")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mt20px"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("救援单数量超出上限值时，平台费用单价")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxPrice),
      expression: "maxPrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.chargeRecord == 1,
      "maxlength": "20",
      "onkeyup": "if(isNaN(value))execCommand('undo')",
      "onafterpaste": "if(isNaN(value))execCommand('undo')"
    },
    domProps: {
      "value": (_vm.maxPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validDates),
      expression: "!validDates"
    }],
    staticClass: "cus_message form-group__message"
  }, [_vm._v("小数点保留最多两位")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right",
    staticStyle: {
      "padding-right": "75px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.chargeRecord == 1
    },
    on: {
      "click": _vm.addMileagePrice
    }
  }, [_vm._v("新增")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table mt20px table-striped table-bordered",
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.billingRuleData), function(fileInfo, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index!=0"
      }],
      staticClass: "glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          return _vm.deleteMessage(index)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fileInfo.startNumber),
        expression: "fileInfo.startNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "readonly": _vm.chargeRecord == 1,
        "type": "text"
      },
      domProps: {
        "value": (fileInfo.startNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fileInfo, "startNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fileInfo.endNumber),
        expression: "fileInfo.endNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "readonly": _vm.chargeRecord == 1,
        "type": "text"
      },
      domProps: {
        "value": (fileInfo.endNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fileInfo, "endNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fileInfo.platformPrice),
        expression: "fileInfo.platformPrice"
      }],
      staticClass: "form-control",
      attrs: {
        "readonly": _vm.chargeRecord == 1,
        "type": "text",
        "onKeyPress": "if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 || /\\.\\d\\d$/.test(value))event.returnValue=false"
      },
      domProps: {
        "value": (fileInfo.platformPrice)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fileInfo, "platformPrice", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.validDates || _vm.chargeRecord == 1
    },
    on: {
      "click": _vm.saveRescueOrder
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\r\n\t\t\t" + _vm._s(_vm.messageStr) + "\r\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsgBill",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsgbill
    }
  }, [_vm._v("\r\n\t\t\t" + _vm._s(_vm.messageStr) + "\r\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsgbill
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmModalMsgbill
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group pt5px mr40px",
    staticStyle: {
      "margin-left": "55px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("计费控制")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group pt5px mr40px",
    staticStyle: {
      "margin-left": "55px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("计费规则")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "2%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "red",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("*救援单数量起始值，大于")]), _vm._v(" "), _c('th', {
    staticClass: "red",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("*救援单数量上限值，小于等于")]), _vm._v(" "), _c('th', {
    staticClass: "red",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("*平台费用单价")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c16df91","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/billingmanagement/PageBillingMangeMent.vue
// module id = 1557
// module chunks = 0